import type { StepsTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const stepsDark: StepsTheme = {
  name: 'Steps',
  common: commonDark,
  self
}

export default stepsDark
